var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4H6.80769C4.70033 4 3.64665 4 2.93745 4.73723C2.80762 4.87219 2.68857 5.02299 2.58202 5.18744C2 6.08576 2 7.42042 2 10.0897V11.282C2 13.5172 2 14.6347 2.56587 15.4202C2.75462 15.6822 2.98443 15.9121 3.24643 16.1008C4.03192 16.6667 5.14948 16.6667 7.38462 16.6667C9.30756 16.6667 10.269 16.6667 10.943 16.0464C11.1607 15.8461 11.3521 15.6036 11.5103 15.3278C12 14.4741 12 13.2562 12 10.8205V10.3333C12 7.42889 12 5.97667 11.3188 5.04321C11.2732 4.98076 11.2257 4.92061 11.1764 4.86289C10.4395 4 9.29298 4 7 4Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 9.33325H9.33333",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H7.66667",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 2.60533C5.48855 2.34338 5.67642 2.11302 5.89004 1.9227C6.55152 1.33341 7.4951 1.33341 9.38225 1.33341V1.33341C11.5217 1.33341 12.5915 1.33341 13.3558 1.85413C13.6663 2.0657 13.9344 2.33374 14.146 2.64429C14.6667 3.40859 14.6667 4.47834 14.6667 6.61783V7.58169C14.6667 10.1176 14.6667 11.3856 14.0955 12.239C13.9909 12.3953 13.8741 12.5385 13.7467 12.6667",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8e5c9c91574729a380876ae5a079f563.svg";
export { ForwardRef as ReactComponent };